export default "__VITE_ASSET__D3cJSV2O__"